import { useMutation } from '@tanstack/react-query'
import { gameBoxRoomService } from '../../../../services/games/games-boxes-rooms'

export const useUpdateGameBoxRoom = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: gameBoxRoomService.update,
  })

  return {
    update: mutateAsync,
    isLoading: isPending,
  }
}
